module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('div', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 2002 by Alejandro Murguía")]), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_vm._v("First edition, 2002")]), _vm._v(" "), _c('div', {
    staticClass: "copy1"
  }, [_vm._v("Requests for permission to reproduce material from this work should be sent to Permissions, University of Texas Press, P.O. Box 7819, Austin, TX 78713-7819."), _c('br'), _c('a', {
    attrs: {
      "href": "http://utpress.utexas.edu/index.php/rp-form",
      "target": "_blank"
    }
  }, [_vm._v("utpress.utexas.edu/index.php/rp-form")])]), _vm._v(" "), _c('div', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_vm._v("Library ebook ISBN: 978-0-292-79637-9")]), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_vm._v("Individual ebook ISBN: 9780292796379")]), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_vm._v("DOI: 10.7560/752658")]), _vm._v(" "), _c('div', {
    staticClass: "copy1"
  }, [_vm._v("Murguía, Alejandro, 1949–")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_vm._v("The medicine of memory : a Mexican clan in California / by Alejandro Murguía. — 1st ed.")]), _vm._v(" "), _c('div', {
    staticClass: "copy",
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN")]), _vm._v(" 0-292-75265-2 (alk. paper) — "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN")]), _vm._v(" 0-292-75267-9 (pbk. : alk. paper)")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_vm._v("1. Mexican Americans—California—Biography. 2. Mexican Americans—California—History. 3. Mexican American families—California—History. 4. Aztecs—First contact with Europeans—California—History. 5. Lugo family. 6. Olivas family. 7. Murguía family. 8. Murguía, Alejandro, 1949– . 9. Mexican Americans—California—San Francisco—Biography. 10. San Francisco (Calif.)—Biography. I. Title.")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v("870."), _c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v("5"), _c('span', {
    staticClass: "small"
  }, [_vm._v("M")]), _vm._v("87    2002")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_vm._v("929’.2’0973—dc21")]), _vm._v(" "), _c('div', {
    staticClass: "copy",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("2002010187")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_vm._v("Frontispiece: Mission Dolores, 1856, watercolor, José Clemente Orozco Farías.")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_vm._v("Front cover photos: Soledad Lugo, c. 1944; the Murguías (standing, left to right) Arturo, Alvar, Enrique, Luis, (sitting, left to right) Petra and Margarita, and two unidentified children, Mexico City, c. 1940; (background) Mission Dolores, 1856, watercolor, José Clemente Orozco Farías.")]), _vm._v(" "), _c('div', {
    staticClass: "copy2"
  }, [_vm._v("Back cover: (left to right) Ygnacio Lugo, Ramona Nájera Olivas Lugo, and Antonio Lugo, Colonia Horcasitas, San Fernando Valley, 1936. Photo courtesy of Roberto Olivas.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 66
// module chunks = 0